import React from 'react'
import styled from '@emotion/styled'

import { Image } from './Image'
import { cssImageStyle, cssImageWrapper, cssRecipeImageAndCookingTimeWrapper } from './styles'
import { Recipe } from '@library/menu-service'

const ImageWrapper = styled.button(
  () =>
    ({
      ...cssImageWrapper,
      label: '-TileImage',
    } as any),
)

const ContentWrapper = styled.div(cssRecipeImageAndCookingTimeWrapper as any)

export function TileImage({
  lazy,
  recipe,
  insideOverflow = false,
}: {
  lazy: boolean
  recipe: Recipe
  insideOverflow?: boolean
}) {
  return (
    <ImageWrapper>
      <ContentWrapper>
        <Image lazy={lazy} styles={cssImageStyle} recipe={recipe} insideOverflow={insideOverflow} />
      </ContentWrapper>
    </ImageWrapper>
  )
}
